const DUEDATE ='DUEDATE';
const STATUS ='STATUS';
const USERS ='USERS';
const ACTIVATE_WORKGROUP_BY_DUEDATE ='ACTIVATE_WORKGROUP_BY_DUEDATE';
const ACTIVATE_WORKGROUP_BY_STATUS ='ACTIVATE_WORKGROUP_BY_STATUS';
const ACTIVATE_DUEDATE_BY_USERS ='ACTIVATE_DUEDATE_BY_USERS';
const ACTIVATE_STATUS_BY_USERS ='ACTIVATE_STATUS_BY_USERS';
const ACTIVATE_WORKGROUP ='ACTIVATE_WORKGROUP';
const TITLE = 'Tickets with Due Date older than';
const TITLE_RESOLVED_TODAY = 'Today\'s Activity';
const SEGMENT_BY = 'Segment By:';
const TAB_DUE_DATE = 'Due Date';
const TAB_STATUS= 'Status';
const TICKETS_COUNT= 'Tickets Count';
const NUMBER_OF_TICKETS ='Number of Tickets';
const ASSIGNEE= 'Assignee';
const WORKGROUP= 'Workgroup';
const BACK= '< Back';
const DUEDATE_FILTER_LIST=['PastDue', 'DueToday', 'DueTomorrow', 'DueAfterTomorrow', 'Open', 'Resolved', 'UpdatedToday'];
const STATUS_FILTER_LIST=['Open', 'UpdatedToday', 'Resolved'];
const TODAYS_ACTIVITY_LIST = ['Open', 'Resolved'];
const REPORTS_DROP_DOWN_OPTIONS = ['Upcoming Due Dates', 'Today\'s Activity'];
const ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY ='ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY';
const ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN ='ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN';
const RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE ='RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE';
const RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN = 'RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN';
const RESOLVED_DATE_REPORTS_COLOR= ['#FFFF00','#9999A9'];
const DUEDATE_DATE_REPORTS_COLOR= ['#FF3333', '#FE9A2E', '#F3F781', '#5FB404'];
const STATUS_REPORTS_COLOR= ['#FF3333', '#FFFF00', '#9999A9'];
const UPCOMING_DUE_DATES='Upcoming Due Dates';

export const CHART_CONST_INFO={
    DUEDATE,
    STATUS,
    TITLE,
    USERS,
    ACTIVATE_WORKGROUP_BY_DUEDATE,
    ACTIVATE_WORKGROUP_BY_STATUS,
    ACTIVATE_DUEDATE_BY_USERS,
    ACTIVATE_STATUS_BY_USERS,
    ACTIVATE_WORKGROUP,
    SEGMENT_BY,
    TAB_DUE_DATE,
    TAB_STATUS,
    TICKETS_COUNT,
    NUMBER_OF_TICKETS,
    ASSIGNEE,
    WORKGROUP,
    BACK,
    DUEDATE_FILTER_LIST,
    STATUS_FILTER_LIST,
    REPORTS_DROP_DOWN_OPTIONS,
    TITLE_RESOLVED_TODAY,
    ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY,
    ACTIVATE_WORKGROUP_BY_DUEDATE_RESOLVED_TODAY_ASSIGNEE_DRILL_DOWN,
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE,
    RESOLVED_DATE_REPORTS_GROUP_BY_ASSIGNEE_FOR_ASSIGNEEID_DRILL_DOWN,
    UPCOMING_DUE_DATES,
    RESOLVED_DATE_REPORTS_COLOR,
    DUEDATE_DATE_REPORTS_COLOR,
    STATUS_REPORTS_COLOR,
    TODAYS_ACTIVITY_LIST
};